import React, { Component } from 'react';

export function Downloads() {
    return (
        <>
            <h1>1 DOWNLOADS</h1>
        </>
    )
}